const useEmailCapture = (article) => {
  const { body, partner, sponsor, featuredClass, instructorClass, marketingTags, noMBGMarketing } =
    article
  let marketingFocus = "User Growth"

  if (partner) {
    marketingFocus = "Partnership"
  }

  if (sponsor) {
    marketingFocus = "Sponsorship"
  }

  if (featuredClass || instructorClass) {
    marketingFocus = "Classes"
  }

  if (marketingTags?.some((tag) => tag.match(/supplements/))) {
    marketingFocus = "Products"
  }

  body.some(({ type, url, classId }) => {
    if (
      (type === "product" && classId) ||
      url?.match(/mindbodygreen\.com\/(classes|coaching)\/[a-zA-Z0-9\-]+/)
    ) {
      marketingFocus = "Classes"
      return true
    }
    return false
  })

  // only show the email captures if we are not suppressing marketing or have classes
  return !noMBGMarketing && marketingFocus === "User Growth" ? getInlineEmailDetails(article) : null
}

const getInlineEmailDetails = ({ subcategory, marketingTags: tags }) => {
  // stickyTitle, stickySubtitle, and stickyCTA can be used to override the values on sticky units
  if (subcategory?.toLowerCase() === "beauty") {
    return {
      inlineEmailType: "beauty",
      title: "Heal Your Skin.",
      stickyTitle: "Heal Your Skin",
      subtitle: "Receive your <strong>FREE</strong> Doctor-Approved Beauty Guide",
      stickySubtitle: "Our <strong>FREE doctor-approved beauty guide</strong>",
      confirmationTitle: "Thank You!",
      confirmationSubtitle:
        "Check your inbox for your <strong>FREE</strong> Doctor-Approved Beauty Guide.",
      cta: "UNLOCK",
      stickyCTA: "CLAIM YOUR FREE GUIDE",
      mailingList: "beauty_guide_sign_ups",
      mailingListSource: "beauty_guide",
      segmentTrackingId: "beauty-guide",
      whiteLogo: true,
    }
  } else if (tags) {
    if (tags.includes("parenting") || (subcategory && subcategory.toLowerCase() === "parenting")) {
      return {
        inlineEmailType: "parenting-sleep",
        title: "Sleep Like Before You Had Kids.",
        stickyTitle: "Better Sleep Awaits",
        subtitle:
          "Receive your <strong>FREE</strong> Parents' Guide to Getting a Good Night's Sleep",
        stickySubtitle: "Our FREE <strong>Guide to a Good Night's Sleep.</strong>",
        confirmationTitle: "Thank You!",
        confirmationSubtitle:
          "Check your inbox for your <strong>FREE</strong> Parents' Guide to Getting a Good Night's Sleep.",
        cta: "UNLOCK",
        stickyCTA: "CLAIM YOUR FREE GUIDE",
        mailingList: "parenting_sleep_guide_sign_ups",
        mailingListSource: "ultimate_sleep_guide",
        segmentTrackingId: "parenting-sleep-v2",
        whiteLogo: true,
      }
    } else if (tags.includes("sleep")) {
      return {
        inlineEmailType: "ultimate-sleep",
        title: "Your Best Sleep Ever.",
        subtitle:
          "Receive your <strong>FREE</strong> Ultimate Guide to Getting a Good Night's Sleep.",
        stickySubtitle: "Our FREE <strong>Guide to a Good Night's Sleep.</strong>",
        confirmationTitle: "Thank You!",
        confirmationSubtitle:
          "Check your inbox for your <strong>FREE</strong> Ultimate Guide to Getting a Good Night's Sleep.",
        cta: "UNLOCK",
        stickyCTA: "CLAIM YOUR FREE GUIDE",
        mailingList: "ultimate_sleep_guide_sign_ups",
        mailingListSource: "ultimate_sleep_guide",
        segmentTrackingId: "ultimate-sleep-v2",
        whiteLogo: true,
      }
    } else if (
      tags.includes("astrology") ||
      tags.includes("spirituality") ||
      (subcategory && subcategory.toLowerCase() === "spirituality")
    ) {
      return {
        inlineEmailType: "sex-love-guide",
        title: "Sex life in retrograde?",
        subtitle: "Your <strong>FREE</strong> Astrology Sex, Love and Attraction Guide.",
        stickySubtitle: "Your <strong>FREE</strong> Astrology Sex, Love and Attraction Guide.",
        confirmationTitle: "Thank You For Signing Up!",
        confirmationSubtitle:
          "Can't wait for the latest wellness news and inspiration? Follow us on social to stay tuned everywhere.",
        cta: "UNLOCK",
        stickyCTA: "UNLOCK ACCESS",
        mailingList: "sex_love_guide",
        mailingListSource: "sex_love_guide_inline",
        segmentTrackingId: "sex-love-guide",
      }
    }
  }

  return null
}

export default useEmailCapture
